import React, { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import AccordionServicos from './accordionServicos'
import BadgetOtimize from './badget-otimize'
import Container from './container'

// Circle Card component for the CTA
const CircleCard = () => {
  const { openModal } = useModal()
  const [isHovered, setIsHovered] = useState(false)

  function handleMouseEnter() {
    setIsHovered(true)
  }

  function handleMouseLeave() {
    setIsHovered(false)
  }

  return (
    <div className="relative flex items-center justify-center hover:cursor-pointer h-full">
      <div
        className="relative w-[300px] h-[300px]"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleMouseEnter}
        onTouchEnd={handleMouseLeave}
      >
        {/* Colored border using gradient */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021]" />

        {/* Inner circle with content */}
        <div className="absolute inset-[2px] rounded-full bg-[#0F083A] flex flex-col items-center justify-center p-8 text-center overflow-hidden">
          {/* Red blur effect on hover - positioned inside the circle at top-right */}
          <div
            className={`absolute top-0 right-0 w-36 h-36 transition-opacity duration-300 blur-3xl ${
              isHovered ? 'opacity-100' : 'opacity-0'
            }`}
            style={{ backgroundColor: '#FC0021' }}
          />

          {/* Content positioned above the blur */}
          <div className="relative z-10 flex flex-col items-center">
            <h3 className="text-4xl font-inter-light text-white my-4 text-center">
              Otimize seu negócio!
            </h3>
            <button
              type="button"
              onClick={() => openModal(<FormularioRD />)}
              className="bg-white text-[#110940] font-poppins-light rounded-full py-2 px-6 flex items-center mt-4 hover:bg-opacity-90 hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              Contratar
              <span className="ml-2 rotate-45">↑</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function DevopsBeneficios() {
  const [openAccordionId, setOpenAccordionId] = useState(null)
  const benefitsData = [
    {
      id: 1,
      icon: '../assets/servicos/velocidade_icon.svg',
      title: 'Velocidade',
      text: 'Faça entregas rápidas e ágeis com integração contínua.',
    },
    {
      id: 2,
      icon: '../assets/servicos/agilidade_icon.svg',
      title: 'Agilidade',
      text: 'Garanta resposta rápida e assertiva às demandas do mercado.',
    },
    {
      id: 3,
      icon: '../assets/servicos/transforme_estrategia_icon.svg',
      title: 'Transforme sua Estratégia',
      text: 'Implemente DevOps, CI/CD, IaC e monitoramento contínuo para lançar produtos com agilidade, qualidade e eficiência, e prepare sua empresa para liderar o mercado.',
    },
    {
      id: 4,
      icon: '../assets/servicos/qualidade_icon.svg',
      title: 'Qualidade',
      text: 'Realize monitoramento e testes automatizados e garanta máxima confiabilidade.',
    },
    {
      id: 5,
      icon: '../assets/servicos/cicd_icon.svg',
      title: 'CI/CD',
      text: 'Automatize o ciclo de desenvolvimento, integrando e testando o código continuamente. Acelere o lançamento de novos produtos, minimizando erros e otimizando a eficiência.',
    },
    {
      id: 6,
      icon: '../assets/servicos/infraestrutura_icon.svg',
      title: 'Infraestrutura Como Código (IaC)',
      text: 'Automatize e padronize a gestão de infraestrutura e garanta consistência e escalabilidade em todos os ambientes.',
    },
    {
      id: 7,
      icon: '../assets/servicos/monitoramento_continuo_icon.svg',
      title: 'Monitoramento Contínuo',
      text: 'Mantenha alta performance com monitoramento em tempo real, identificando problemas antes que impactem os usuários.',
    },
    {
      id: 8,
      icon: '../assets/servicos/transforme_estrategia_icon.svg',
      title: 'Transforme Sua Estratégia',
      text: 'Adote DevOps, CI/CD, IaC e monitoramento contínuo para lançar produtos com rapidez, qualidade e eficiência, colocando sua empresa à frente no mercado.',
    },
  ]

  const BenefitCard = ({ icon, title, text }) => {
    const [isHovered, setIsHovered] = useState(false)

    function handleMouseEnter() {
      setIsHovered(true)
    }

    function handleMouseLeave() {
      setIsHovered(false)
    }

    return (
      <div
        className="relative hover:cursor-pointer"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleMouseEnter}
        onTouchEnd={handleMouseLeave}
      >
        {/* Card with sharp white borders */}
        <div className="relative bg-[#FFFFFF17] h-full rounded-lg border-1 border-white/80 overflow-hidden">
          {/* Red blur effect on hover - contained within the card */}
          <div
            className={`absolute top-0 right-0 size-36 transition-opacity duration-300 blur-3xl ${
              isHovered ? 'opacity-100' : 'opacity-0'
            }`}
            style={{ backgroundColor: '#FC0021' }}
          />

          {/* Content container - positioned above the blur */}
          <div className="relative z-10 py-8 px-6">
            <div className="relative w-14 h-14 mb-6">
              <div
                className={`absolute inset-0 rounded-full ${
                  isHovered
                    ? 'bg-gradient-to-r from-[#FC0021] to-[#4B3BDB] opacity-100'
                    : 'bg-white/10 blur-[2px]'
                }`}
              />
              <div className="absolute inset-[2px] rounded-full bg-[#252237] flex items-center justify-center">
                <img src={icon} alt={title} className="w-7 h-7" />
              </div>
            </div>
            <h3 className="text-2xl font-inter-bold mb-4 text-white">
              {title}
            </h3>
            <p className="text-white font-inter-regular text-lg">{text}</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <section className="relative pt-14 pb-24 md:py-24 bg-[url(../assets/beneficios-mobile.png)] bg-cover lg:bg-gradient-to-b lg:from-[#040116] lg:via-[#140B48] lg:to-[#0F083A] overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 h-[60px] bg-[#FC0021] blur-2xl opacity-85 scale-110" />

      <Container className="relative z-10 space-y-9 md:space-y-16">
        <h2 className="text-2xl md:text-[64px] font-inter-light text-white text-center">
          Benefícios
        </h2>

        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {/* Benefit cards */}
          {benefitsData.map((benefit, index) => (
            <BenefitCard
              key={index}
              icon={benefit.icon}
              title={benefit.title}
              text={benefit.text}
            />
          ))}

          {/* Large circle with colored border as a grid item */}
          <CircleCard />
        </div>

        <div className="md:hidden space-y-3">
          {benefitsData.map((benefit, index) => (
            <div key={index} className="space-y-4">
              <button
                type="button"
                onClick={() =>
                  setOpenAccordionId(
                    openAccordionId === benefit.id ? null : benefit.id,
                  )
                }
                className="w-full"
              >
                <AccordionServicos
                  {...benefit}
                  className="ring-1 ring-white bg-[rgba(255,255,255,0.09)] backdrop-blur-[92px]"
                  doesThereButton={false}
                />
              </button>
              {openAccordionId === benefit.id && <BadgetOtimize />}
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
